import React, { useEffect, useState } from "react";

import { toast } from "react-hot-toast";
import { Input } from "components/Form";
import { Button } from "components/Button/Button";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import ModalBox from "components/modal/ModalBox";
import { updateSubject } from "services/subject/subjectController";
import { updateInterviewStudent } from "services/student/studentController";

const UpdateInterviewStudent = ({ open, onClose, selectedData, interviewStudentListing }) => {
    const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
    console.log("sle", selectedData);

    const [studentData, setStudentData] = useState({
        id: "",
        firstname: "",
        lastname: "",
        email: ""
    });

    const [errorField, setErrorField] = useState({
        firstname: "",
        lastname: "",
        email: ""
    });

    //*********************Handel Validation********************************** */
    const handleValidation = () => {
        let errorField = {};
        let formIsValid = true;

        if (!studentData.firstname) {
            errorField["firstname"] = "Please Enter First Name";
            formIsValid = false;
        }
        if (!studentData.lastname) {
            errorField["lastname"] = "Please Enter Last Name";
            formIsValid = false;
        }
        if (!studentData.email) {
            errorField["email"] = "Please Enter EmailID";
            formIsValid = false;
        }

        if (!studentData.mobile) {
            errorField["mobile"] = "Please Enter Mobile";
            formIsValid = false;
        }

        setErrorField(errorField);
        return formIsValid;
    };

    // this function is used for clear data on close
    const modalOnClose = () => {
        setStudentData({
            firstname: "",
            lastname: "",
            email: ""
        });
        onClose();
    };

    //*********************Submit Subject Handler********************************** */
    const submitStudentHandler = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            setSubmitLoading(true);
            try {
                const res = await updateInterviewStudent({
                    id: selectedData.id,
                    firstName: studentData.firstname,
                    lastName: studentData.lastname,
                    email: studentData.email,
                    mobile: studentData.mobile
                });
                if (res.code === 200) {
                    toast.success(res.message);
                    modalOnClose();
                    interviewStudentListing();
                    setSubmitLoading(false);
                } else {
                    toast.error(res.message);
                    setSubmitLoading(false);
                }
            } catch (err) {
                toast.error(err?.response?.data?.message || err.message);
                setSubmitLoading(false);
            }

        } else {
            toast.error("Please fill all the fields");
        }
    };

    //   onChange Handler
    const onChangeHandler = (e) => {
        const { name, value } = e.target;

        if (name === "email") {
            setStudentData({ ...studentData, email: value });
            return;
        }

        // only letters for names
        if ((name === "firstname" || name === "lastname") && !/^[a-zA-Z\s]*$/.test(value)) {
            return;
        }

        setStudentData({ ...studentData, [name]: value });
    };


    useEffect(() => {
        setStudentData({ firstname: selectedData.firstname, lastname: selectedData.lastname, email: selectedData.email, mobile: selectedData.mobile });
    }, [selectedData]);

    return (
        <>
            <ModalBox
                status={open}
                onClose={modalOnClose}
                title={"Update Interview Student"}
                customizedFooter={
                    <div>
                        <Button onClick={submitStudentHandler} {...submitButtonElement}>
                            Update Student
                        </Button>
                    </div>
                }
            >
                <div className="form-group row">
                    {/* First Name */}
                    <div className="col-sm-6 col-form-label">
                        <Input
                            type="text"
                            name="firstname"
                            value={studentData.firstname}
                            onChange={onChangeHandler}
                            placeholder="Enter First Name"
                            className="form-control"
                            maxLength={30}
                            label="First Name"
                            error={errorField.firstname}
                            required
                        />
                    </div>

                    {/* Last Name */}
                    <div className="col-sm-6 col-form-label">
                        <Input
                            type="text"
                            name="lastname"
                            value={studentData.lastname}
                            onChange={onChangeHandler}
                            placeholder="Enter Last Name"
                            className="form-control"
                            maxLength={30}
                            label="Last Name"
                            error={errorField.lastname}
                            required
                        />
                    </div>

                    {/* Email */}
                    <div className="col-sm-12 col-form-label">
                        <Input
                            type="email"
                            name="email"
                            value={studentData.email}
                            onChange={onChangeHandler}
                            placeholder="Enter EmailID"
                            className="form-control"
                            label="Email"
                            error={errorField.email}
                            required
                        />
                    </div>
                    <div className="col-sm-12 col-form-label">
                    <Input
                        type="tel"
                        name="mobile"
                        value={studentData.mobile}
                        onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, ""); // remove non-digits
                            if (value.length <= 10) {
                                onChangeHandler({
                                    target: { name: "mobile", value }
                                });
                            }
                        }}
                        placeholder="Enter Mobile"
                        className="form-control"
                        label="Mobile"
                        maxLength={10}
                        inputMode="numeric"
                        pattern="[0-9]*"
                        error={errorField.mobile}
                        required
                    />
                    </div>

                </div>
            </ModalBox>
        </>
    );
};

export default UpdateInterviewStudent;
